import React from "react";
import PropTypes from "prop-types";

const TrendCharts = props => {
    const handleError = (index) => {
        document.getElementById(`TrendChart_${index}`).hidden = true;
    };
    let charts =  props.charts.map((item) => {        
        let index = item.imageSrc.length > 0 ? item.imageSrc[item.imageSrc.length-1] : "0";
        return (
            <div key={Math.random()} id={`TrendChart_${index}`}>
                <img src={`${item.imageSrc}?SSO=${props.token}`} alt={item.imageAlt} title={item.imageAlt} onError={() => {handleError(index);}}/>
            </div>
        );
    });     
    return (
        <div style={{textAlign: "center"}}>
            {charts}
        </div>
    );
};

TrendCharts.propTypes = {
    charts: PropTypes.array.isRequired,
    token: PropTypes.string.isRequired,
};

export default TrendCharts;